// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import Val_Verde from '../../../Texas/data/counties/Val_Verde.geo.json'
import Edwards from '../../../Texas/data/counties/Edwards.geo.json'
import Real from '../../../Texas/data/counties/Real.geo.json'
import Bandera from '../../../Texas/data/counties/Bandera.geo.json'
import Kerr from '../../../Texas/data/counties/Kerr.geo.json'
import Gillespie from '../../../Texas/data/counties/Gillespie.geo.json'
import Kendall from '../../../Texas/data/counties/Kendall.geo.json'
import Comal from '../../../Texas/data/counties/Comal.geo.json'
import Kinney from '../../../Texas/data/counties/Kinney.geo.json'
import Uvalde from '../../../Texas/data/counties/Uvalde.geo.json'
import Medina from '../../../Texas/data/counties/Medina.geo.json'
import Bexar from '../../../Texas/data/counties/Bexar.geo.json'
import Guadalupe from '../../../Texas/data/counties/Guadalupe.geo.json'
import Gonzales from '../../../Texas/data/counties/Gonzales.geo.json'
import Wilson from '../../../Texas/data/counties/Wilson.geo.json'
import Karnes from '../../../Texas/data/counties/Karnes.geo.json'
import Atascosa from '../../../Texas/data/counties/Atascosa.geo.json'
import Maverick from '../../../Texas/data/counties/Maverick.geo.json'
import Zavala from '../../../Texas/data/counties/Zavala.geo.json'
import Frio from '../../../Texas/data/counties/Frio.geo.json'
import Dimmit from '../../../Texas/data/counties/Dimmit.geo.json'
import La_Salle from '../../../Texas/data/counties/La_Salle.geo.json'
import County from '../../../Texas/types/County'

const counties: { [key: string]: County } = {
  Val_Verde,
  Edwards,
  Real,
  Bandera,
  Kerr,
  Gillespie,
  Kendall,
  Comal,
  Kinney,
  Uvalde,
  Medina,
  Bexar,
  Guadalupe,
  Gonzales,
  Wilson,
  Karnes,
  Atascosa,
  Maverick,
  Zavala,
  Frio,
  Dimmit,
  La_Salle
}

export const countyCollection = {
  type: 'FeatureCollection',
  properties: {
    kind: 'county',
    state: 'Texas'
  },
  features: Object.values(counties)
}

export default counties
